import { useCallback, useEffect, useMemo, useState } from 'react'

import { AllChatterTableType } from '@/modules/tracking/chatter-tracking/service/chatter-tracking-service.ts'

export const useChatterOverviewSelect = (chatters: AllChatterTableType[]) => {
  const [selectedChatters, setSelectedChatters] =
    useState<AllChatterTableType[]>(chatters)

  const allSelect = useCallback(() => {
    setSelectedChatters(() => chatters)
  }, [chatters])

  const allRemove = useCallback(() => {
    setSelectedChatters([])
  }, [])

  const addSelect = useCallback((chatter: AllChatterTableType) => {
    setSelectedChatters((prev) => [
      ...prev.filter((c) => c.name !== chatter.name),
      chatter,
    ])
  }, [])

  const removeSelect = useCallback((chatter: AllChatterTableType) => {
    setSelectedChatters((prev) => [...prev].filter((x) => x !== chatter))
  }, [])

  useEffect(() => {
    setSelectedChatters(chatters)
  }, [chatters])

  return useMemo(
    () => ({
      selectedChatters,
      allSelect,
      allRemove,
      addSelect,
      removeSelect,
    }),
    [selectedChatters, allSelect, allRemove, addSelect, removeSelect],
  )
}
